import { render, staticRenderFns } from "./ModuleNodesList.vue?vue&type=template&id=5436b638"
import script from "./ModuleNodesList.vue?vue&type=script&lang=js"
export * from "./ModuleNodesList.vue?vue&type=script&lang=js"
import style0 from "./ModuleNodesList.vue?vue&type=style&index=0&id=5436b638&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports